import React, { useState } from "react";
import jwtDecode from "jwt-decode";
import Snackbar from "@mui/material/Snackbar";
import { ThreeDots } from "react-loader-spinner";
import BaseLayout from "../../layout/BaseLayout";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { changeUserPassword } from "../../services/identifiants/IdentifiantsRequest";
import { useEffect } from "react";

const Identifiants = () => {
  const [loading, setLoading] = useState(false);
  const [snackbarSuccessOpen, setSnackbarOpenSuccess] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center",
  });

  const { vertical, horizontal } = snackbarPosition;

  const handleCloseSnackbarSuccess = () => {
    setSnackbarOpenSuccess(false);
  };

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  const clearForm = () => {
    setUsername("");
    setPassword("");
    setNewPassword("");
    setPasswordConfirm("");
  };

  const modifierIdentifiant = () => {
    setLoading(true);

    const data = {
      newPassword: newPassword,
      password: password,
      passwordConfirm: passwordConfirm,
      // username: username,
    };

    changeUserPassword(data)
      .then((res) => {
        setLoading(false);
        clearForm();
        setSuccessMessage("Mot de passe modifié avec succès");
        setSnackbarOpenSuccess(true);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response.data) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Erreur de modification, rééssayer!");
          setSnackbarOpenError(true);
        }
      });
  };

  useEffect(() => {
    const token = localStorage.getItem('momo4scoohclient')

    if (token) {
      const decodedToken = jwtDecode(token)
      setUserInfo(decodedToken)
    }
  }, [])
  

  return (
    <BaseLayout>
      <div className="w-11/12 h-full mx-auto pt-32">
        <h1 className="text-xl font-bold">Modifier mes identifiants</h1>
        <div className="w-full flex flex-col items-center mt-10">
          <div className="w-[450px] h-fit bg-white border rounded-lg p-5">
            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Username</span>
              </label>
              <input
                disabled={true}
                  value={userInfo !== null ? userInfo.username : ''}
                  // onChange={(e) => setUsername(e.target.value)}
                type="text"
                placeholder="mtn"
                className="input input-bordered w-full"
              />
            </div>
            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Ancien mot de passe</span>
              </label>
              <input
                disabled={loading}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="text"
                placeholder="mtn"
                className="input input-bordered w-full"
              />
            </div>
            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Nouveau mot de passe</span>
              </label>
              <input
                disabled={loading}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                type="text"
                placeholder="mtn"
                className="input input-bordered w-full"
              />
            </div>
            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">Confirmer mot de passe</span>
              </label>
              <input
                disabled={loading}
                value={passwordConfirm}
                onChange={(e) => setPasswordConfirm(e.target.value)}
                type="text"
                placeholder="mtn"
                className="input input-bordered w-full"
              />
            </div>
            {!loading ? (
              <button
                disabled={loading}
                className="bg-momo-jaune w-full h-11 rounded-lg mt-5 flex items-center justify-center gap-x-2"
                onClick={modifierIdentifiant}
              >
                <CheckCircleIcon />
                <span className="font-bold">Modifier</span>
              </button>
            ) : (
              <button
                disabled={loading}
                className="bg-momo-jaune w-full h-11 rounded-lg mt-5 flex items-center justify-center"
              >
                <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#000"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={loading}
                />
              </button>
            )}
          </div>
        </div>
      </div>

      {/* SNACKBAR SUCCESS */}
      {successMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarSuccessOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarSuccess}
          key={vertical + horizontal}
        >
          <div className="bg-green-500 text-white px-10 py-3 rounded-lg">
            {successMessage}
          </div>
        </Snackbar>
      ) : null}

      {/* SNACKBAR ERROR */}
      {errorMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarErrorOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarError}
          key={vertical + horizontal}
        >
          <div className="bg-red-500 text-white px-10 py-3 rounded-lg">
            {errorMessage}
          </div>
        </Snackbar>
      ) : null}
    </BaseLayout>
  );
};

export default Identifiants;
